import { StakingData, StakingInfo } from '../model/staking.model';
import { toNumber } from './mapper-utils';

// Mapper for StakingData
export const mapStakingData = (data: any): StakingData => {
    return {
        stakingStatus: data.stakingStatus,
        stakingType: data.stakingType,
        cliffPeriod: toNumber(data.cliffPeriod),
        vestingPeriod: toNumber(data.vestingPeriod),
        endStaking: Number(data.endStaking),
        stakingRewardPercentage: toNumber(data.stakingRewardPercentage),
        createdAt: Number(data.createdAt),
    };
};

export const mapToStakingInfo = (data: any): StakingInfo => {
    return {
        stakingId: data.stakingId,
        stakingDetails: {
            stakingStatus: data.stakingDetails.stakingStatus,
            stakingType: data.stakingDetails.stakingType,
            cliffPeriod: toNumber(data.stakingDetails.cliffPeriod),
            vestingPeriod: toNumber(data.stakingDetails.vestingPeriod),
            endStaking: toNumber(data.stakingDetails.endStaking),
            stakingRewardPercentage: toNumber(data.stakingDetails.stakingRewardPercentage),
            createdAt: toNumber(data.stakingDetails.createdAt)
        }
    };
}
